import Table from '@components/V4/Table/Table';
import SessionModalSection, {
  ActionButton,
} from '@modules/Admin/components/DetailsModal/DetailsModalSection';
import { useContext, useState } from 'react';
import { MentorDetailsPageContext } from '../../MentorDetailsPage';
import SettingsForm from './SettingsForm';

const SettingsTab = () => {
  const { mentor } = useContext(MentorDetailsPageContext);

  const [isEditing, setIsEditing] = useState(false);

  const buttons: ActionButton[] = [{ buttonText: 'Edit', onClick: () => setIsEditing(true) }];

  return isEditing ? (
    <SettingsForm
      className="mt-6"
      userId={mentor?._id || ''}
      isEducationStrategist={mentor?.mentorData?.isEducationStrategist ?? false}
      onCloseEditForm={() => setIsEditing(false)}
    />
  ) : (
    <SessionModalSection className="mt-6" sectionTitle="Settings" buttonsArray={buttons}>
      <Table size="small">
        <Table.Body>
          <Table.Row>
            <Table.Cell>Education Strategist</Table.Cell>
            <Table.Cell>{mentor?.mentorData?.isEducationStrategist ? 'True' : 'False'}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </SessionModalSection>
  );
};

export default SettingsTab;
